import { formatArrayToElSelect } from "./../../utils";
import api from "../../api";

const state = {
  status: "",
  list: []
};

const getters = {
  list_to_select: (state) => formatArrayToElSelect(state.list)
};

const actions = {
  getTimes: ({ commit }) => {
    return new Promise((resolve, reject) => {
      commit("loading");

      api
        .get("/api/deals/times")
        .then((resp) => {
          commit("success");
          commit("list", resp.data);
          resolve(resp);
        })
        .catch((err) => {
          commit("error");
          reject(err);
        });
    });
  }
};

const mutations = {
  loading: (state) => (state.status = "loading"),
  success: (state) => (state.status = "success"),
  error: (state) => (state.status = "error"),
  list: (state, list) => {
    state.list = list;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
